import type { MaybeRefOrGetter, Ref } from 'vue';

import { ref, toValue } from 'vue';

import type { ChartPointerBounds } from './chart-scales';

import { resolvePointerIndex } from './chart-scales';

/** Отступ якоря тултипа от верхней кромки графика. */
const TOOLTIP_ANCHOR_OFFSET_PX = 12;

interface UseChartPointerOptions {
  /** Границы области данных внутри SVG — считаются от его viewport-прямоугольника. */
  bounds: (svgBounds: DOMRect) => ChartPointerBounds;
  count: MaybeRefOrGetter<number>;
  isMeasured: Ref<boolean>;
}

/**
 * Единая обработка указателя для SVG-графиков: активная точка и якорь тултипа.
 */
export const useChartPointer = ({ bounds, count, isMeasured }: UseChartPointerOptions) => {
  const activeIndex = ref<number | null>(null);
  const activeViewportAnchor = ref<{ x: number; y: number } | null>(null);
  const activeSvgBounds = ref<DOMRect | null>(null);

  const handlePointerMove = (event: PointerEvent): void => {
    if (!isMeasured.value) {
      return;
    }

    const svgBounds = (event.currentTarget as SVGElement).getBoundingClientRect();

    activeSvgBounds.value = svgBounds;
    activeViewportAnchor.value = { x: event.clientX, y: svgBounds.top + TOOLTIP_ANCHOR_OFFSET_PX };
    activeIndex.value = resolvePointerIndex(event.clientX, bounds(svgBounds), toValue(count));
  };

  const handlePointerLeave = (): void => {
    activeIndex.value = null;
    activeSvgBounds.value = null;
    activeViewportAnchor.value = null;
  };

  return {
    activeIndex,
    activeSvgBounds,
    activeViewportAnchor,
    handlePointerLeave,
    handlePointerMove,
  };
};
